
<template>
<!-- <Navbar/> -->
<SideBar/>

<div class="card main-content">
        <div class="surface-ground">
        <Card>
            
            <template #content>
            <DataTable :value="filteredRoc" :filters="parentFilter" :loading="loading" tableStyle="min-width: 50rem" paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]"
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}" v-model:expandedRows="expandedRows" dataKey="id"
                    @rowExpand="onRowExpand" @rowCollapse="onRowCollapse">
                    <template #header >
                        <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                            <span class="text-xl text-900 font-bold">Roc List</span>
                            <span class="p-input-icon-left">                                
                                <IconField iconPosition="left">
                                    <InputIcon>
                                        <i class="pi pi-search" />
                                    </InputIcon>
                                    <InputText v-model="filterQuery" placeholder="Keyword Search" size="small"/>
                                </IconField>
                            </span>
                        </div>
                        <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                            <span>
                                <!-- <Button label="New Roc" size="small" icon="pi pi-plus" raised class="mr-2" v-tooltip.top="'Add new ROC details'"/> -->

                                <router-link to="/add-roc" rel="noopener">
                                    <Button label="New Roc" size="small" icon="pi pi-plus" raised class="mr-2" v-tooltip.top="'Add new ROC details'"/>
                                </router-link>
                            </span>
                            <span >
                                <Button class="ml-2 mt-1" icon="pi pi-filter" severity="success" size="small" @click="globalFilter" v-tooltip.top="'Filter'"/>
                                <Button class="ml-2 mt-1" icon="pi pi-filter-slash" size="small" outlined severity="success" @click="clearFilter" v-tooltip.top="'Clear Filter'"/>
                            </span>
                        </div>
                    </template>
                <Column expander style="width: 5rem" />
                <Column field="tender_name" header="Tender Name."></Column>
                <Column field="tender_date" header="Tender Date."></Column>
                <Column field="department.name" header="Department"></Column>
                <Column field="contract_no" header="ROC No."></Column>
                <Column field="contract_date" header="ROC Date"></Column>
                <Column field="period" header="Validity (Years)"></Column>
                <Column header="Status">
                    <template #body="slotProps">
                        <Tag :value="getStatus(slotProps.data)" :severity="getSeverity(slotProps.data)" />
                    </template>
                </Column>
                <Column header="Upload ROC">
                    <template #body="slotProps">
                    <div v-if="slotProps.data.doc_url" class="flex">                
                        <!-- <div class="flex"> -->
                            <div class="flex-initial flex align-items-center justify-content-center ">
                                <Button class="pi pi-file-pdf" severity="danger" size="large" text rounded @click="showDoc(slotProps.data.doc_url)" v-tooltip.top="'View Order Copy'"></Button>
                            </div>
                            <div class="flex-initial flex align-items-center justify-content-center ">
                                <Button icon="pi pi-trash" text rounded severity="warning" v-tooltip.top="'Remove File'" size="large" @click="removeDocument(slotProps.data, slotProps.data.doc_url)"></Button>
                            </div>
                        <!-- </div> -->
                    </div>
                    <div v-else class="flex">
                        <div class="flex-initial flex align-items-center justify-content-center ">
                            <Button icon="pi pi-upload" @click="showFileUploadComponent(slotProps.data)" v-tooltip.top="'Upload Order Copy'"></Button>
                        </div>
                    </div>
                    </template>
                </Column>
                <template #expansion="slotProps">
                    <div class="p-3">
                        <div class="flex flex-wrap align-items-center justify-content-between mb-1">
                            <span>
                            <Button size="small" raised label="Export" icon="pi pi-file-export" @click="exportRocItems" v-tooltip.top="'Export ROC Items'"></Button>
                            </span>
                            <span class="px-4 ">

                                <InputText v-model="filters['global'].value" placeholder="Keyword Search" />

                                <Button class="ml-1" size="small" label="Add Item" raised @click="showDialog(slotProps.data)" first/></span>
                        </div>
                        <DataTable ref="rocItems" v-model:filters="filters" :value="slotProps.data.roc_details" :loading="loading" dataKey="id">
                            
                            <Column header="Sl No.">
                                <template #body="slotProps">
                                    {{ ++slotProps.index }}
                                </template>
                            </Column>
                            <Column field="item_name" header="Item"></Column>
                            <Column field="item_rate" header="Old Rate In-Tax">
                                <template #body="slotProps">
                                    {{ formatCurrency(slotProps.data.item_rate) }}
                                </template>
                            </Column>
                            <Column field="basic" header="Basic">
                                <template #body="slotProps">
                                    {{ formatCurrency(slotProps.data.basic) }}
                                </template>
                            </Column>                            
                            <Column field="oldGst" header="Old Gst (%)">
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.oldGst) }}
                                </template>
                            </Column>
                            <Column field="gst2" header="GST 2.0 (%)">
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.gst2) }}
                                </template>
                            </Column>
                            <Column field="newRate" header="New Rate W/GST 2.0">
                                <template #body="slotProps">
                                    {{ formatCurrency(slotProps.data.newRate) }}
                                </template>
                            </Column>
                            <Column field="category.label.name" header="Category"></Column>
                            <Column field="packing" header="Packing Unit"></Column>
                            <Column field="manufacturer.name" header="Manufacturer"></Column>
                            <Column field="slNo" header="ROC Sl No."></Column>
                            
                            <Column header="Action">
                                <template #body="slotProps">
                                    <Button size="small" class="py-2" label="Update" raised @click="showItemDialog(slotProps.data)"/>
                                </template>
                            </Column>
                            <Column header="CMC">
                                <template #body="slotProps">
                                    <span v-if="slotProps.data.category.label.name =='Equipment' || slotProps.data.category.label.name =='EQUIPMENT'">
                                        <Button size="small" class="py-2 px-3 mr-1" icon="pi pi-plus" raised @click="showCMCDialog(slotProps.data)"/>
                                        <Button size="small" class="py-2" icon="pi pi-window-maximize" severity="success" raised @click="showCMC(slotProps.data)"/>

                                    </span> 

                                </template>
                            </Column>
                            
                        </DataTable>

                        <!-- dialog for adding cmc -->
                        <Dialog :visible="cmcDialogVisibility" modal :closable="false" :header="cmcItem" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                            
                            <div class="formgrid grid mt-2">
                                    <div class="field col-4">
                                        <label for="itemName">Year</label>
                                        <InputNumber v-model="cmcYear" class=" w-full"/>
                                    </div>
                                    <div class="field col-4">
                                        <label for="itemRate">Rate</label>
                                        <InputNumber v-model="cmcRate" class="surface-overlay border-round appearance-none outline-none focus:border-primary w-full" :minFractionDigits="2" :maxFractionDigits="2"/>
                                    </div>
                                    <div class="field col-4">
                                        <label for="itemPacking">GST(%)</label>
                                        <InputNumber v-model="cmcGst" class="surface-overlay border-round appearance-none outline-none focus:border-primary w-full" :minFractionDigits="2" :maxFractionDigits="2"/>
                                    </div>
                            </div>
                            <template #footer>
                                <div class="flex flex-row-reverse flex-wrap">
                                    <div class="flex align-items-center justify-content-center ">
                                        <Button class="flex align-items-center justify-content-center " size="small" label="Close" severity="danger" raised @click="hideCMCDialog"></Button>
                                    </div>
                                    <div class="flex align-items-center justify-content-center">
                                        <Button class="flex align-items-center justify-content-center " size="small" label="Save" severity="success" icon="pi pi-save" raised @click="handleSaveCMC(rocItemData)"/>
                                    </div>
                                </div>
                            </template> 
                        </Dialog>
                        <!-- cmc dialog end -->

                        <!-- show cmc dialog start -->
                        <Dialog :visible="itemCmcDialogVisibility" modal :closable="false" :header="cmcItem" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                            <DataTable :value="cmcArr">
                                <Column field="year" header="Year"></Column>
                                <Column field="rate" header="Rate"></Column>
                                <Column field="gst" header="GST(%)"></Column>
                            </DataTable>

                            <template #footer>
                                <div class="flex flex-row-reverse flex-wrap">
                                    <div class="flex align-items-center justify-content-center ">
                                        <Button class="flex align-items-center justify-content-center " size="small" label="Close" severity="danger" raised @click="hideItemCmc"></Button>
                                    </div>
                                </div>
                            </template> 
                        </Dialog>
                                        <!-- show cmc dialog end -->
                    </div>
                </template>
                <template #footer> In total there are {{ rocs ? rocs.length : 0 }} ROCs. </template>
    <Dialog :visible="dialogVisibility" modal header="Item Details" :closable="false" :style="{ width: '60rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <!-- <template #header> -->
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center"></div>
                    <div class="flex align-items-center justify-content-center"><ProgressSpinner v-if="loadingStatus" style="width: 50px; height: 50px" strokeWidth="5"/></div>
                </div>
        <!-- </template> -->
        <div class="formgrid grid mt-2">
            <div class="field col">
                <label for="itemName">Name:</label>
                <InputText v-model="itemName" class="surface-overlay border-round appearance-none outline-none focus:border-primary w-full"/>
            </div>            
            <div class="field col">
                <label for="itemPacking">Packing:</label>
                <InputText v-model="itemPacking" class="surface-overlay border-round appearance-none outline-none focus:border-primary w-full"/>
            </div>
            <!-- <div class="field col">
                <label for="itemRate">Old Rate</label>
                <InputNumber v-model="itemRate" class="w-full" :minFractionDigits="2" :maxFractionDigits="3"/>
            </div> -->
        </div>

        <div class="formgrid grid mt-2">
            <div class="field col">
                <label for="itemRate">Basic:</label>
                <InputNumber v-model="itemBasic" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" @input="updateBasic"/>
            </div>
            <div class="field col">
                <label for="itemRate">GST 2.0 (%):</label>
                <InputNumber v-model="itemGst" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" @input="updateGst"/>
            </div>
            <div class="field col">
                <label for="itemRate">New Rate 2.0:</label>
                <InputNumber v-model="newRate" class="w-full" :minFractionDigits="2" :maxFractionDigits="4" variant="filled" readonly/>
            </div>
        </div>

        <!-- v-if="!itemUpdateStatus" -->
        <div class="formgrid grid mt-2" >
             <div :class="`field ${isEquipment==true? 'col-3' : 'col-5'}`">
                <label for="itemcategory">Category:</label>
                <TreeSelect v-model="itemcategory" :options="categories" placeholder="Select Item" class="w-full" @change="checkCategory"/>
             </div>
             <div v-if="isEquipment" class="field col">
                <label for="installationStatus">Installation Reqd:</label>
                <Dropdown class="w-full" size="small" v-model="installationStatus" :options="installationOptions" optionValue="value" optionLabel="label" placeholder="Select an option"/>
                <InlineMessage v-if="installationStatusError" >Field is required</InlineMessage>

             </div>
            <div :class="`field ${isEquipment==true? 'col-4' : 'col-5'}`">
                <label for="itemManufacturer">Manufacturer:</label>
                <Dropdown size="small" class="w-full" v-model="itemManufacturer" editable filter :options="manufacturers" optionValue="id" optionLabel="name" placeholder="Select Manufacturer"/>
            </div>
            <div class="field col-2">
                <label >Sl No.:</label>
                <InputText v-model="itemSlNo" class="w-full"/>
            </div>
        </div>

        <template #footer>
            <div class="flex flex-row-reverse flex-wrap">
                <div class="flex align-items-center justify-content-center ">
                    <Button class="flex align-items-center justify-content-center " size="small" label="Close" severity="danger" raised @click="hideDialog"></Button>
                </div>
                <div v-if="!itemUpdateStatus" class="flex align-items-center justify-content-center mr-2">
                    <Button class="flex align-items-center justify-content-center " size="small" label="Save" severity="success" icon="pi pi-save" raised @click="handleSave"/>
                </div>
                <div v-if="itemUpdateStatus" class="flex align-items-center justify-content-center mr-2">
                    <Button class="flex align-items-center justify-content-center " size="small" label="Update" severity="success" icon="pi pi-save" raised @click="updateItem"/>
                </div>
            </div>
        </template> 
    </Dialog>
            </DataTable>
            </template>
    </Card>

    <FileUploadComponent v-if="uploadComponent" :visibility="uploadComponent" :poId="rocId" :poNo="rocNo" @close-upload-dialog="closeFileComponent" documentType="roc"></FileUploadComponent>

    <Dialog :visible="deleteFileDialog" modal :closable="false"  :style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <!-- :header="deleteFileHeader" -->

        <!-- <template #header>                
        </template> -->
        <div class="flex justify-content-between flex-wrap mb-5">
            <div class="flex align-items-center justify-content-center ">
                <div class="text-xl font-semibold">
                    {{ deleteFileHeader }}
                </div>
            </div>
            <div class="flex align-items-center justify-content-center ">
                <i v-if="docDeleteProcessing" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
        </div>

        <div class="flex">
            <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i></div>
            <div class="flex align-items-center justify-content-center ">
                <p >
                    Are you sure you want to delete the ROC Copy?
                </p>
            </div>                            
        </div>
                        
        <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <Button class="flex align-items-center justify-content-center my-1 mx-1" size="small" label="Delete" severity="danger" raised @click="deleteRocDoc"></Button>
            
            <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="secondary" text raised @click="deleteFileDialog=false"></Button>
        </div>
        </template>
    </Dialog>
        
        </div>
    </div>

</template>


<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Card from 'primevue/card';
import { getRocList, getCategories, getManufacturers, rocNewItem, updateRocItem, addItemCMC, fetchCMC, fetchOrderCopy, deleteOrderCopy } from '../../services/apiService'
import Tag from 'primevue/tag';
// import Navbar from '../header/headerNavbar.vue'
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Dialog from 'primevue/dialog';
import { FilterMatchMode } from 'primevue/api'
// import CascadeSelect from 'primevue/cascadeselect';
import TreeSelect from 'primevue/treeselect';
import ProgressSpinner from 'primevue/progressspinner';
import SideBar from '../sidebar/sideBarTwo.vue'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import InlineMessage from 'primevue/inlinemessage';
import FileUploadComponent from '../fileUpload/fileUploadComponent.vue';

export default {
    components:{
        // Navbar, 
        SideBar,
        DataTable, 
        Column, 
        Card, 
        Tag, 
        Button ,
        Dropdown,
        InputText,
        InputNumber,
        Dialog,
        // CascadeSelect,
        TreeSelect,
        ProgressSpinner,
        IconField,
        InputIcon,
        InlineMessage, 
        FileUploadComponent,       
    },
    data() {
        return {
            loading:false,
            rocs: [],
            filteredRoc:[],
            filterQuery:null,
            slNo:0,
            expandedRows: [],
            dialogVisibility:false,
            categories:[],
            manufacturers:[],
            rocId:null,
            itemcategory:null,
            itemManufacturer:null,
            itemName:null,
            itemRate:0,
            newRate:0,
            itemBasic:0,
            itemGst:0,
            itemPacking:null,
            itemUpdateStatus:false,
            itemId:null,
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                item_name: { value: null, matchMode: FilterMatchMode.IN },
                "manufacturer.name":{ value: null, matchMode: FilterMatchMode.IN },
            },
            parentFilter: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                tender_name: { value: null, matchMode: FilterMatchMode.IN },
                "department.name":{ value: null, matchMode: FilterMatchMode.IN },
                contract_no:{ value: null, matchMode: FilterMatchMode.IN },
            },
            cmcDialogVisibility:false,
            cmcItem:null,
            cmcYear:0,
            cmcRate:0,
            cmcGst:0,
            itemCmcDialogVisibility:false,
            cmcArr:[],
            selectedCascadeItemCategory:null,
            keyId:null,
            loadingStatus:false,
            rocItemData:null,
            installationStatus:null,
            equipCategory:null,
            isEquipment:false,
            installationOptions:[
                {label:'No', value:'0'},
                {label:'Yes', value:'1'},
            ],
            installationStatusError:false,
            uploadComponent:false,
            rocNo:null,
            deleteFileDialog:false,
            fileDoc:null,
            deleteFileHeader:null,
            docDeleteProcessing:false,
            itemSlNo:null,
        };
    },

    methods:{
        getRocs(){
            this.loadingStatus = true;
            this.loading = true;
            getRocList([]).then((res)=> 
            {
                this.rocs = res.data
                this.filteredRoc = res.data;
                this.loading = false;
                this.loadingStatus = false;                
            }
            ).catch((error)=>this.showErrorToast(error.response.data));
        },
        getCategory(){
            return new Promise((resolve, reject) => {
                getCategories().then((res)=> 
                    {
                        this.categories = res.data
                        resolve(this.categories);
                    }
                    ).catch((error)=>{reject(error.response.data); this.showErrorToast(error.response.data)});
            });
            // getCategories().then((res)=> 
            //     {
            //         this.categories = res.data
            //     }
            //     ).catch((error)=>this.showErrorToast(error.response.data));
        },
        getManufacturer(){
            getManufacturers().then((res)=> 
                {
                    this.manufacturers = res.data;
                }
                ).catch((error)=>this.showErrorToast(error.response.data));
        },
        getStatus(product){
            switch (product.status) {
                case 1:
                    return 'Active'
                case -1:
                    return 'Expired';
                default:
                    break;
            }
        },
        getSeverity(product){
            switch (product.status) {
                case 1:
                    return 'success'
                case -1:
                    return 'danger';
                default:
                    break;
            }
        },
        formatCurrency(value) {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        formatNumber(value) {
            return value.toLocaleString('en-IN');
        },
        showDialog(data){
            // this.installationStatus = '0';
            this.getCategory().then(()=>{
                this.equipCategory = (this.categories.find((category) => {
                    if(category.label == 'Equipments' || category.label == 'Equipment' || category.label == 'EQUIPMENTS' || category.label == 'EQUIPMENT'){
                        return category;
                    }
                })).key;
            });
            this.getManufacturer();
            this.isEquipment = false;
            this.rocId = data.id;
            this.dialogVisibility = true;
        },
        hideDialog(){
            this.dialogVisibility = false;
            this.itemUpdateStatus = false;
            this.clearData();
        },
        showItemDialog(data){

            if(data.manufacturer){
                this.itemManufacturer = data.manufacturer.id;
            }            
        
            this.itemUpdateStatus = true;
            this.itemId = data.id;
            this.itemName = data.item_name;
            this.itemRate = data.item_rate;
            this.newRate = data.newRate;
            this.itemPacking = data.packing;
            this.itemBasic = data.basic;
            this.itemGst = data.gst2;
            this.itemSlNo = data.slNo;
            this.getManufacturer();
            this.itemcategory = {[data.category.key]:true};
            this.installationStatus = data.installationStatus;
            this.getCategory().then(()=>{
                this.equipCategory = (this.categories.find((category) => {
                    if(category.label == 'Equipments' || category.label == 'Equipment' || category.label == 'EQUIPMENTS' || category.label == 'EQUIPMENT'){
                        return category;
                    }
                })).key;
                Object.keys(this.itemcategory)[0] == this.equipCategory ? this.isEquipment = true : this.isEquipment = false;
                this.dialogVisibility = true;      
            });
        },
        checkCategory(){
            if(Object.keys(this.itemcategory)[0] == this.equipCategory){
                this.isEquipment = true;
                this.installationStatus = '1';
            }else{
                this.isEquipment = false;
                this.installationStatus = '0';
            }        
        },
        showCMCDialog(data){
            this.cmcItem = data.item_name+': CMC Charges';
            this.rocItemData = data;
            this.cmcDialogVisibility = true;
        },
        showCMC(data){

            fetchCMC(data.id).then((res)=>{
                this.cmcArr = res.data;
                this.cmcItem = data.item_name+':CMC Charges';
                this.itemCmcDialogVisibility = true;
            }).catch((error)=>this.showErrorToast(error.response.data));
        },
        hideItemCmc(){
            this.itemCmcDialogVisibility = false;
        },
        hideCMCDialog(){
            this.cmcDialogVisibility = false;
        },
        handleSave(){
            
            if(this.installationStatus==null && this.isEquipment){
                this.installationStatusError = true;
                return;
            }
            if(this.rocId==null || this.itemName==null || this.itemBasic==null || this.itemGst==null || this.newRate==null || this.itemPacking==null || this.itemcategory==null){
                return this.showErrorToast({'message':'All fields are required!'});
            }          

            const data ={
                'rocId':this.rocId,
                'name':this.itemName,
                'rate':this.itemRate,
                'basic':this.itemBasic,
                'gst2':this.itemGst,
                'newRate':this.newRate,
                'packing':this.itemPacking,
                'category':this.itemcategory,
                'installationStatus':this.installationStatus,
                'manufacturer':this.itemManufacturer,
                'slNo':this.itemSlNo,
            }

            this.loadingStatus = true;
            rocNewItem(data).then((res)=>{
                this.showSuccessToast(res.data);
                this.hideDialog();
                this.getRocs();
                this.loadingStatus = false;
                this.rocId = null;
                this.itemName = null;
                this.itemRate = 0; //default to zero, used previously for rate incl gst for old gst regime
                this.itemPacking = null;
                this.itemcategory = null;
                this.itemManufacturer = null;
                this.installationStatus = 0;
            }).catch((error)=>this.showErrorToast(error.response.data));
        },
        handleSaveCMC(data){         
            if(this.cmcYear==0 || this.cmcYear=='' || this.cmcRate==0 || this.cmcRate=='' || this.cmcGst==0 || this.cmcGst==''){
                return this.showErrorToast({'message':'None of the fields can be ZERO(0)'});
            }
            const cmcData = {
                'itemId':data.id,
                'year':this.cmcYear,
                'rate':this.cmcRate,
                'gst':this.cmcGst,
            };

            addItemCMC(cmcData).then((res)=>{
                this.showSuccessToast(res.data);
                this.hideCMCDialog();
                this.cmcYear = 0;
                this.cmcRate = 0;
                this.cmcGst = 0;
            }).catch((error)=>this.showErrorToast(error.response.data));
        },
        updateItem(){

            if(this.newRate==0){
                return this.showErrorToast({'message':'Rate cannot be ZERO (0)'});
            }
            const data ={
                'itemId':this.itemId,
                'name':this.itemName,
                'oldRate':this.itemRate, //used previously during old gst regime
                'oldGst':(((this.itemRate - this.itemBasic)/this.itemBasic) * 100),
                'basic':this.itemBasic,
                'gst2':this.itemGst,
                'newRate':this.newRate,
                'packing':this.itemPacking,
                'category':this.itemcategory,
                'installationStatus':this.installationStatus,
                'manufacturer':this.itemManufacturer,
                'slNo':this.itemSlNo,
            }

            this.loadingStatus = true;
            updateRocItem(data).then((res)=>{  
                this.showSuccessToast(res.data);
                this.hideDialog();
                this.clearData();
                this.getRocs();
                this.itemUpdateStatus = false;
                this.loadingStatus = false;
            }).catch((error)=>{this.showErrorToast(error.response.data); this.loadingStatus = false;});

        },
        updateGst(event){
            this.itemGst = event.value;
            this.updateRate();
        },
        updateBasic(event){
            this.itemBasic = event.value;
            this.updateRate();
        },
        updateRate(){
            this.newRate = this.itemBasic + (this.itemBasic * (this.itemGst/100));
        },
        showFileUploadComponent(data){
            this.uploadComponent = true;
            this.rocNo = data.contract_no;
            this.rocId = data.id;
            
        },
        closeFileComponent(visible, flag){
            this.uploadComponent = visible;
            this.rocId = null;
            if(flag==1){
                this.getRocs();
            }
        },
        showDoc(url){
            fetchOrderCopy(url).then().catch((error)=>{
                this.showErrorToast(error.response.data);
            })
        },
        removeDocument(po, path){    
            let startIndex = path.indexOf("path=");
            let url = path.slice(startIndex+5);
            this.rocNo = po.id;
            this.fileDoc = url;
            this.deleteFileDialog = true;
            this.deleteFileHeader = 'ROC No.: '+po.contract_no;
        },
        deleteRocDoc(){
            this.docDeleteProcessing = true;
            deleteOrderCopy({
                po:this.rocNo, 
                path:this.fileDoc,
                type:'roc',
            }).then((res)=>{
                this.showSuccessToast(res.data);
                this.docDeleteProcessing = false;
                this.deleteFileDialog = false;
                this.getRocs();
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            });
        },
        clearData(){
            this.itemId = null;
            this.itemName = null;
            this.itemRate = null;
            this.itemPacking = null;
            this.itemcategory = null;
            this.itemManufacturer = null;
            this.installationStatus = 0;
            this.isEquipment = false;
        },
        exportRocItems(){
            this.$refs.rocItems.exportCSV();
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        globalFilter(){
            this.filteredRoc = [];
            const condition = new RegExp(this.filterQuery, 'gi')
            if(this.filterQuery!=null){

                this.rocs.forEach(e => {
                    if (e.tender_name.match(condition) || e.contract_no.match(condition)) { 
                        this.filteredRoc.push(e); 
                    }
                    else{
                        e.roc_details.every(el => {
                            if(el.item_name.match(condition)){
                                this.filteredRoc.push(e);
                                return false;
                            }
                            return true;
                        });
                    }
                });
            }
        },
        clearFilter(){
            this.filteredRoc = this.rocs;
            this.filterQuery = null;
        } 
    },
    mounted() {
        this.getRocs()
        
    }
};
</script>

